module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/7-e15af580fafb784cb0749a43343f048f.jpg";